import { z } from "zod";
import { TENANT_ROLES } from "./organizations.js";
import { emailSchema } from "./validation.js";
import { plainTextField } from "./public-api.js";
/** Roles a tenant_admin may assign (never platform roles; never elevate to tenant_admin). */
export const TENANT_ADMIN_ASSIGNABLE_ROLES = ["publisher", "editor", "auditor"];
/** Platform owner may also grant tenant_admin within a tenant. */
export const PLATFORM_ASSIGNABLE_TENANT_ROLES = TENANT_ROLES;
export const inviteMembershipSchema = z.object({
    email: emailSchema,
    displayName: plainTextField(120),
    role: z.enum(TENANT_ROLES),
    /** Initial password for new users; ignored when inviting an existing user. */
    password: z.string().min(12).max(128).optional(),
    actorPassword: z.string().min(1).max(128),
});
export const activateMembershipSchema = z.object({
    actorPassword: z.string().min(1).max(128),
});
export const updateMembershipRoleSchema = z.object({
    role: z.enum(TENANT_ROLES),
    actorPassword: z.string().min(1).max(128),
});
export const membershipActionSchema = z.object({
    actorPassword: z.string().min(1).max(128),
});
export const membershipListItemSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    userId: z.string(),
    email: z.string().email(),
    displayName: z.string(),
    role: z.enum(TENANT_ROLES),
    status: z.enum(["invited", "active", "suspended", "removed"]),
    userActive: z.boolean(),
    invitedAt: z.string().nullable(),
    activatedAt: z.string().nullable(),
    updatedAt: z.string(),
});
export function tenantRoleToLegacyRole(role) {
    if (role === "tenant_admin")
        return "publisher";
    return role;
}
//# sourceMappingURL=memberships.js.map